import * as React from "react";
import "./styles/FooterTextButton.scss";

interface Props {
    onClick: (nameId: string) => void;
    title: string;
    nameId: string;
    highlight: boolean;
    style?: any;
}


const FooterTextButton: React.FC<Props> = ({onClick, title, nameId, highlight, style}) => {
    return (
        <div className={"footer-text-button-container"}>
            <span style={style} onClick={() => onClick(nameId)} className={highlight ? "text highlight" : "text"}>{title}</span>
        </div>
    )
}

export default FooterTextButton;